module.exports = __webpack_public_path__ + "static/media/parallel-yellow.036c5f52.svg";